import { Layout } from "@/components/Layout";
import { SEO } from "@/components/SEO";
import { useTranslation } from "react-i18next";
import headerImage from "@/assets/headers/header-normas.jpg";

const Normas = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEO 
        title={t('houseRules.title')}
        description={t('houseRules.respect.text1')}
        keywords="normas terreiro, código ética umbanda, vestimenta giras, comportamento terreiro, regras umbanda orlando"
        canonicalUrl={`${window.location.origin}/normas`}
      />
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
        <div className="absolute inset-0 bg-logo-brown-dark/70" />
        <div className="relative z-10 text-center px-4 container mx-auto">
          <h1 className="font-display text-5xl md:text-7xl text-logo-beige mb-6 font-bold">
            {t('houseRules.title')}
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto font-body">
            {t('houseRules.subtitle')}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          
          {/* Respeito */}
          <div className="mb-16">
            <h2 className="font-display text-4xl text-sand-dark mb-6 drop-shadow-[0_2px_4px_rgba(28,45,74,0.15)]">
              {t('houseRules.respect.title')}
            </h2>
            <div className="space-y-4 text-foreground/80 leading-relaxed">
              <p>{t('houseRules.respect.text1')}</p>
              <p>{t('houseRules.respect.text2')}</p>
              <p>{t('houseRules.respect.text3')}</p>
            </div>
          </div>

          <div className="h-px bg-sand-dark/20 my-12" />

          {/* Silêncio */}
          <div className="mb-16">
            <h2 className="font-display text-4xl text-sand-dark mb-6 drop-shadow-[0_2px_4px_rgba(28,45,74,0.15)]">
              {t('houseRules.silence.title')}
            </h2>
            <div className="space-y-4 text-foreground/80 leading-relaxed">
              <p>{t('houseRules.silence.text1')}</p>
              <p>{t('houseRules.silence.text2')}</p>
              <p>{t('houseRules.silence.text3')}</p>
            </div>
          </div>

          <div className="h-px bg-sand-dark/20 my-12" />

          {/* Vestimenta */}
          <div className="mb-16">
            <h2 className="font-display text-4xl text-sand-dark mb-6 drop-shadow-[0_2px_4px_rgba(28,45,74,0.15)]">
              {t('houseRules.clothing.title')}
            </h2>
            <div className="space-y-4 text-foreground/80 leading-relaxed">
              <p>{t('houseRules.clothing.text1')}</p>
              
              <div className="bg-sand-light/20 p-6 rounded-lg border border-sand-dark/10 my-6">
                <h4 className="font-display text-xl text-sand-dark mb-3">{t('houseRules.clothing.recommended')}</h4>
                <ul className="space-y-2">
                  {(t('houseRules.clothing.recommendedItems', { returnObjects: true }) as string[]).map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>

              <div className="bg-sand-light/20 p-6 rounded-lg border border-sand-dark/10 my-6">
                <h4 className="font-display text-xl text-sand-dark mb-3">{t('houseRules.clothing.avoid')}</h4>
                <ul className="space-y-2">
                  {(t('houseRules.clothing.avoidItems', { returnObjects: true }) as string[]).map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>

              <p><strong>{t('houseRules.clothing.shoesNote')}</strong></p>

              <h4 className="font-display text-xl text-sand-dark mt-6 mb-3">{t('houseRules.clothing.electronics')}</h4>
              <p>{t('houseRules.clothing.electronicsText1')}</p>
              <p>{t('houseRules.clothing.electronicsText2')}</p>
            </div>
          </div>

          <div className="h-px bg-sand-dark/20 my-12" />

          {/* Proibições */}
          <div className="mb-16">
            <h2 className="font-display text-4xl text-sand-dark mb-6 drop-shadow-[0_2px_4px_rgba(28,45,74,0.15)]">
              {t('houseRules.prohibitions.title')}
            </h2>
            
            <div className="bg-accent-red/10 p-8 rounded-lg border-l-4 border-accent-red">
              <p className="font-display text-xl text-sand-dark mb-6">
                {t('houseRules.prohibitions.intro')}
              </p>
              
              <ul className="space-y-3 text-foreground/80">
                {(t('houseRules.prohibitions.items', { returnObjects: true }) as string[]).map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <span className="text-accent-red mt-1">✗</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <p className="mt-6 text-foreground/80 font-medium">
                {t('houseRules.prohibitions.warning')}
              </p>
            </div>
          </div>

          <div className="bg-sand-light/30 p-8 rounded-lg text-center mt-12">
            <p className="text-foreground/80 leading-relaxed italic">
              {t('houseRules.closing')}
            </p>
            <p className="font-display text-2xl text-sand-dark mt-6">Axé!</p>
          </div>

        </div>
      </section>
    </div>
    </Layout>
  );
};

export default Normas;